import config from '@/config';

export default {
    // baseUrl: `${config.server.host}:${config.server.port}/v1`,
    baseUrl: `${config.server.host}:${config.server.port}/api-v2`,
    baseUrlPayments: `${config.externalPayment.host}:${config.externalPayment.port}/v1`,
    baseUrlV1: `${config.server.host}:${config.server.port}`,
}
